module.exports = __webpack_public_path__ + "img/图片2.b76b17a1.png";